<!--
 * @Description: 附件管理
 * @Author: 
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 16:35:44
-->
<template>
  <div class="pages_content attachment">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="main_right">
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav"><i style="margin-right: 5px;" class="el-icon-arrow-down"></i></span>
              <transition name="to"></transition>
              <span v-show="showCardNav"><i style="margin-right: 5px;" class="el-icon-arrow-up"></i></span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px">名称</span>
                  <el-input v-model="tableParam.apiName" placeholder="请输入操作人" style="width: 220px;" clearable  @keyup.enter.native="queryPage()"/>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">类别</span>
                  <el-select v-model="tableParam.foreignId" placeholder="请选择" style="width:220px;">
                    <el-option v-for="item in messagetype" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), queryPage()">
                  查 询
                </el-button>
                <el-button size="medium" class="bottom_all_two" @click="reset()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div></div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px;">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <!-- 列表 -->
            <div class="card_info" :style="style">
              <el-table ref="multipleTable" v-loading="loading" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index) in table">
                  <el-table-column v-if="item.status" :key="index" :label="item.label" align="center" :width="item.width" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <!-- <div class="top_page_totle">总共{{ total }}条</div> -->
          <el-pagination :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :current-page.sync="tableParam.page" @size-change="sizeChange" @current-change="queryPage()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="queryPage()">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import breaDcrumb from '@/components/breadcrumb';
import { mapGetters } from 'vuex';
import { query_page } from '@/api/basedata/log.js';
import { getDicType } from '@/api/common';
export default {
  components: {
    breaDcrumb
  },
  data() {
    return {
      loading: false,
      /*弹要修改过着添加的数据*/
      /*判断收起展开*/
      tableData: [],
      showCardNav: true,
      table: [
        { label: '名称', width: 'auto', prop: 'apiName', status: true },
        { label: '类别', width: 'auto', prop: 'type', status: true },
        { label: '发布者', width: 'auto', prop: 'userName', status: true },
        { label: '发布时间', width: 'auto', prop: 'requestTime', status: true },
      ],
      /*列表选中的数据集*/
      tableParam: {
        page: 1,
        pageSize: 10,
        apiName: "",
        foreignId: '',
        foreignType: '',
        types: "type_message",
      },
      total: 0,
      messagetype: [],
      ButtonList: []
    };
  },
  mounted() {
    this.ButtonList = this.$ButtonList()
    getDicType({ code: 'messagetype' }).then(res => {
      this.messagetype = res.data.items;
    });
    this.queryPage();
  },
  methods: {
    /*重置*/
    reset() {
      this.tableParam = this.$options.data().tableParam
      this.queryPage();
    },

    /*获取列表*/
    queryPage() {
      this.loading = true
      query_page(this.tableParam).then(res => {
        this.loading = false
        this.total = res.data.totalCount;
        this.tableData = res.data.list;
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.queryPage();
    },
  },
  computed: {
    ...mapGetters({
      screenWidth: 'getscreenWidth',
      screenHeight: 'getscreenHeight',
      Collapse: 'getsCollapse',
    }),
    style() {
      let num = 0;
      if (this.Collapse) {
        num = this.screenWidth - 124;
      } else {
        num = this.screenWidth - 221;
      }
      return 'width:' + num + 'px;';
    }
  }
};
</script>
<style lang="scss" scoped>
.attachment {
  .el-link {
    i {
      color: $bg_color;
    }
  }
  .el-link:hover {
    color: $bg_color;
  }
  font-size: $font_size;
  .el-main {
    padding: 0;
    display: flex;
    overflow: hidden;
  }
  .main_right {
    height: 100%;
    overflow: auto;
  }
  .main_right::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .main_right::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  .main_right::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }
  .main_right::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  .main_right::-webkit-scrollbar-corner {
    background: #179a16;
  }
  .search {
    padding: 20px;
  }
  .header_right {
    @include discen_al;
    padding: 0 20px;
    justify-content: space-between;
    .title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
    }
  }
  .card_nav {
    padding: 0 20px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card_info {
    padding: 0 20px;
  }
  .card_bottom {
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    .card_bottom_left {
      display: flex;
      align-items: center;
      font-size: $font_size;
    }
  }
}
</style>
